/** QuickRouter — Accès unifié aux empreintes : projet > atelier > gabarits > intégrées. */
import { BUILTIN_FOOTPRINTS, builtinFootprint } from './footprints.js';
import { TEMPLATE_FOOTPRINTS, BOARD_TEMPLATES, templateById } from './boards.js';

export { BUILTIN_FOOTPRINTS, TEMPLATE_FOOTPRINTS, BOARD_TEMPLATES, templateById };

const TPL = new Map(TEMPLATE_FOOTPRINTS.map((f) => [f.id, f]));

/** Fonction id → empreinte (ou null) pour un projet donné. `custom` = empreintes d'atelier. */
export function makeLookup(project, custom = []) {
  const own = new Map((project?.footprints ?? []).map((f) => [f.id, f]));
  const shop = new Map(custom.map((f) => [f.id, f]));
  const cache = new Map();
  return (id) => {
    if (cache.has(id)) return cache.get(id);
    const f = own.get(id) ?? shop.get(id) ?? TPL.get(id) ?? builtinFootprint(id) ?? null;
    cache.set(id, f);
    return f;
  };
}

/** Catalogue consultable (intégrées + gabarits + atelier + projet), sans doublon. */
export function catalog(project, custom = []) {
  const seen = new Set();
  const out = [];
  for (const f of [...(project?.footprints ?? []), ...custom, ...BUILTIN_FOOTPRINTS, ...TEMPLATE_FOOTPRINTS]) {
    if (seen.has(f.id)) continue;
    seen.add(f.id);
    out.push(f);
  }
  return out;
}

const norm = (s) => String(s ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

export function searchFootprints(list, query = '', category = '') {
  const words = norm(query).split(/\s+/).filter(Boolean);
  return list.filter((f) => {
    if (category && f.category !== category) return false;
    const hay = norm([f.id, f.name, f.category, f.description, ...(f.tags ?? []), f.defaults?.mpn].join(' '));
    return words.every((w) => hay.includes(w));
  });
}
